import { render, staticRenderFns } from "./RelatedAgentsCardsStyle.vue?vue&type=template&id=4e456036&"
import script from "./RelatedAgentsCardsStyle.vue?vue&type=script&lang=js&"
export * from "./RelatedAgentsCardsStyle.vue?vue&type=script&lang=js&"
import style0 from "./RelatedAgentsCardsStyle.vue?vue&type=style&index=0&id=4e456036&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports